import axios from 'axios';
import Producto from '@/models/Producto';
import Pedido from '@/models/Pedido';
import moment from 'moment';
function defaultState() {
	return {
		productos: [],
		allproductos: [],
		allstart: 0,
		alllimit: 12,
		allpage: 1,
		visitados: [],
		comprados: [],
		promociones: [],
		total: 0,
		totalpedidos: 0,
		carrito: [],
		pedidos: [],
		unegocio: [],
		familia: [],
		subfamilia: [],
		presentacion: [],
		rubro: [],
		subrubro: [],
		linea: [],
		marca: [],
		fdepagos: [],
		dentregas: [],
		torigen: [],
		toperacion: [],
		fecha_entrega: '',
		idcarrito: 0,
		origen: null,
		operacion: null,
		entrega: null,
		totalpedido: '',
		detallepedido: '',
		productodetallado: [],
		loadingvisita: false,
		loadinghistorial: false,
		loadingproductos: false,
		loadingallproductos: false,
		totales: [],
		posiciones: [],
		diasentrega: '',
		importes: [],
		loadingcarrito: false,
		alertaprecio: [],
		pedidospendientes: [],
		pedidosaprobados: [],
		pedidosaplicados: [],
		filter: {
			patron: '',
			familia_id: '',
			subfamilia_id: '',
			unidad: '',
			presentacion_id: '',
			rubro_id: '',
			subrubro_id: '',
			linea_id: '',
			marca_id: '',
			es_nuevo: false,
			es_promocion: false,
		},
		_prodReqId: 0,
		_allReqId: 0,
	};
}
const state = defaultState();
const mutations = {
	setLoadingCarrito(state: { loadingcarrito: boolean }, loading: boolean) {
		state.loadingcarrito = loading;
	},
	setProductos(state: { productos: Producto[] }, productos: Producto[]) {
		state.productos = productos;
	},
	setAllProductos(state: { allproductos: Producto[] }, productosall: Producto[]) {
		//state.allproductos.push(...productosall);
		productosall.length > 0 ? state.allproductos.push(...productosall) : (state.allproductos = []);
	},
	setDiasEntrega(state: { diasentrega: string }, dias: string) {
		state.diasentrega = dias;
	},
	setProductoDetallado(state: { productodetallado: Producto }, productos: Producto) {
		state.productodetallado = productos;
	},
	setVisitados(state: { visitados: Producto[] }, visitados: Producto[]) {
		state.visitados = visitados;
	},
	setComprados(state: { comprados: Producto[] }, comprados: Producto[]) {
		state.comprados = comprados;
	},
	setPromociones(state: { promociones: Producto[] }, promociones: Producto[]) {
		state.promociones = promociones;
	},
	setTotal(state: { total: number }, total: number) {
		state.total = total;
	},
	setTotalPedidos(state: { totalpedidos: number }, total: number) {
		state.totalpedidos = total;
	},
	setOrigen(state: { origen: number }, origen: number) {
		state.origen = origen;
	},
	setOperacion(state: { operacion: number }, operacion: number) {
		state.operacion = operacion;
	},
	setEntrega(state: { entrega: number }, entrega: number) {
		state.entrega = entrega;
	},
	setCarrito(state, carrito) {
		state.carrito = carrito;
	},
	setIdcarrito(state: { idcarrito: number }, idcarrito: number) {
		idcarrito = idcarrito ? idcarrito : 0;
		state.idcarrito = idcarrito;
	},
	setTotalPedido(state: { totalpedido: number }, total: number) {
		state.totalpedido = total;
	},
	setUnegocio(state: { unegocio: number }, unegocio: number) {
		state.unegocio = unegocio;
	},
	setFamilia(state: { familia: number }, familia: number) {
		state.familia = familia;
	},
	setSubfamilia(state: { subfamilia: number }, subfamilia: number) {
		state.subfamilia = subfamilia;
	},
	setPresentacion(state: { presentacion: number }, presentacion: number) {
		state.presentacion = presentacion;
	},
	setRubro(state: { rubro: number }, rubro: number) {
		state.rubro = rubro;
	},
	setSubrubro(state: { subrubro: number }, subrubro: number) {
		state.subrubro = subrubro;
	},
	setLinea(state: { linea: number }, linea: number) {
		state.linea = linea;
	},
	setMarca(state: { marca: number }, marca: number) {
		state.marca = marca;
	},
	setFdepagos(state: { fdepagos: number }, fdepagos: number) {
		state.fdepagos = fdepagos;
	},
	setDentregas(state: { dentregas: number }, dentregas: number) {
		state.dentregas = dentregas;
	},
	setTorigen(state: { torigen: number }, torigen: number) {
		state.torigen = torigen;
	},
	setToperacion(state: { toperacion: number }, toperacion: number) {
		state.toperacion = toperacion;
	},
	setFechaEntrega(state, fecha) {
		state.fecha_entrega = fecha;
	},
	setLoadingProductos(state, loading) {
		state.loadingproductos = loading;
	},
	setLoadingAllProductos(state, loading) {
		state.loadingallproductos = loading;
	},
	/*setLoadingVisita(state, loading) {
		state.loadingvisita = loading;
	},
	setLoadingHistorial(state, loading) {
		state.loadinghistorial = loading;
	},*/
	setDetallePedido(state: { detallepedido: string }, detalle: string) {
		state.detallepedido = detalle;
	},
	setAlertaPrecio(state: { alertaprecio: [] }, alerta: []) {
		state.alertaprecio = alerta;
	},
	setPosiciones(state: { posiciones: number }, posicion: number) {
		state.posiciones = posicion;
	},
	setPedidos(state: { pedidos: Producto }, pedidos: Producto) {
		state.pedidos = pedidos;
	},
	setTotales(state: { totales: number }, totales: number) {
		state.totales = totales;
	},
	setImportes(state: { importes: number }, importes: number) {
		state.importes = importes;
	},
	setPedidosPendientes(state: { pedidospendientes: Pedido[] }, pedidospendientes: Pedido | Pedido[]) {
		!Array.isArray(pedidospendientes) ? state.pedidospendientes.push(pedidospendientes) : (state.pedidospendientes = []);
	},
	setPedidosAprobados(state: { pedidosaprobados: Pedido[] }, pedidosaprobados: Pedido | Pedido[]) {
		!Array.isArray(pedidosaprobados) ? state.pedidosaprobados.push(pedidosaprobados) : (state.pedidosaprobados = []);
	},
	setPedidosAplicados(state: { pedidosaplicados: Pedido[] }, pedidosaplicados: Pedido | Pedido[]) {
		!Array.isArray(pedidosaplicados) ? state.pedidosaplicados.push(pedidosaplicados) : (state.pedidosaplicados = []);
	},
	setFilter(state: { filter: object }, filter: object) {
		state.filter = filter;
	},
	setAllStart(state: { allstart: number }, allstart: number) {
		state.allstart = allstart;
	},
	setAllLimit(state: { alllimit: number }, alllimit: number) {
		state.alllimit = alllimit;
	},
	setAllPage(state: { allpage: number }, allpage: number) {
		state.allpage = allpage;
	},
	SET_PEDIDOS_FILTER_KEY(state, { key, value }) {
		state.filter[key] = value;
	},
};
const actions = {
	setPedidosFilterBulk({ commit }, obj) {
		Object.keys(obj || {}).forEach(key => commit('SET_PEDIDOS_FILTER_KEY', { key, value: obj[key] }));
	},
	async applyFilters({ commit, dispatch, state }, { filtros, start = 0, limit = 12, page = 1, patron = '' }) {
		const final = { ...(state.filter || {}), ...filtros, patron };
		await dispatch('saveFilter', final);
		await dispatch('loadProductos', { params: { filtros: final, start, limit, page } });
	},
	async loadAllStart({ commit, dispatch }, start) {
		commit('setAllStart', start);
	},
	async loadAllPage({ commit, dispatch }, page) {
		commit('setAllPage', page);
	},
	async saveFilter({ commit, dispatch }, filter) {
		console.log('este es filter', filter);
		commit('setAllStart', 0);
		commit('setAllPage', 1);
		commit('setFilter', filter);
		commit('setAllProductos', []);
	},
	async addProducto({ commit, dispatch }, producto: { pedido_id: number }): Promise<void> {
		return axios.put('./api/public/proxy/pedidos/' + producto['pedido_id'] + '?type=carrito&suma=true', producto).then(response => {
			this.dispatch('loadCarrito');
		});
	},
	async removeProducto({ commit, dispatch }, params: Object): Promise<void> {
		return axios.delete('./api/public/proxy/pedidos', params).then(response => {
			this.dispatch('loadCarrito');
		});
	},
	async removeAll({ commit, dispatch }, params: Object): Promise<void> {
		return axios.delete('./api/public/proxy/pedidos', params).then(response => {
			this.dispatch('loadCarrito');
			commit('setTotalPedido', 0);
		});
	},
	async confirmCarrito({ commit, dispatch }, idcarrito: number): Promise<void> {
		let config = { params: { pedidoid: idcarrito } };
		return axios.put('./api/public/proxy/pedidos', config);
	},
	async loadUnegocio({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=unegocio').then(response => {
			commit('setUnegocio', response.data.productos);
		});
	},
	async loadFamilia({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/pedidos?type=familia&subfamilia_id=${params.subfamilia_id}
			&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&presentacion_id=${params.presentacion_id}`
			)
			.then(response => {
				commit('setFamilia', response.data.productos);
			});
	},
	// async cambiaPrecio({ commit, dispatch }, params): Promise<void> {
	// 			return axios
	// 				.get(
	// 					`./api/public/proxy/pedidos?type=subfamilia&familia_id=${params.familia_id}
	// 		&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&presentacion_id=${params.presentacion_id}`
	// 				)
	// 				.then(response => {
	// 					commit('setSubfamilia', response.data.productos);
	// 				});
	// },
	async loadSubfamilia({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/pedidos?type=subfamilia&familia_id=${params.familia_id}
			&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&presentacion_id=${params.presentacion_id}`
			)
			.then(response => {
				commit('setSubfamilia', response.data.productos);
			});
	},
	async loadPresentacion({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/pedidos?type=presentacion&familia_id=${params.familia_id}
			&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&subfamilia_id=${params.subfamilia_id}`
			)
			.then(response => {
				commit('setPresentacion', response.data.productos);
			});
	},
	async loadRubro({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/pedidos?type=rubro&familia_id=${params.familia_id}
			&presentacion_id=${params.presentacion_id}&subrubro_id=${params.subrubro_id}&subfamilia_id=${params.subfamilia_id}`
			)
			.then(response => {
				commit('setRubro', response.data.productos);
			});
	},
	async loadSubrubro({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/pedidos?type=subrubro&familia_id=${params.familia_id}
			&rubro_id=${params.rubro_id}&presentacion_id=${params.presentacion_id}&subfamilia_id=${params.subfamilia_id}`
			)
			.then(response => {
				commit('setSubrubro', response.data.productos);
			});
	},
	async loadLinea({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=linea').then(response => {
			commit('setLinea', response.data.productos);
		});
	},
	async loadMarca({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=marca').then(response => {
			commit('setMarca', response.data.productos);
		});
	},
	async loadCarrito({ commit, dispatch }): Promise<void> {
		commit('setLoadingCarrito', true);
		return axios.get('./api/public/proxy/pedidos?type=carrito').then(response => {
			commit('setCarrito', response.data.productos.productos);
			commit('setEntrega', response.data.productos.destino_id);
			commit('setOrigen', response.data.productos.origen_id);
			commit('setOperacion', response.data.productos.tipo_operacion_id);
			let dias = 0;
			response.data.productos.productos.forEach(element => {
				if (dias < element.dias_de_entrega) dias = element.dias_de_entrega;
			});
			commit('setDiasEntrega', dias);
			//TODO: sacar a otro metodo. Lo intente da error distpatch pq no trae parametros.
			let productos = response.data.productos.productos;
			let totales: object[] = [];
			if (productos.length > 0) {
				const countBy = <T extends Record<string, string>, K extends keyof T>(arr: T[], prop: K): Record<string, number> =>
					arr.reduce((prev, curr) => ((prev[curr[prop]] = ++prev[curr[prop]] || 1), prev), {} as Record<string, number>);
				const arra = countBy(productos, 'unimed_venta_completa');
				Object.keys(arra).forEach(element => {
					let suma: number = 0;
					productos.forEach(producto => {
						if (producto.unimed_venta_completa === element) suma = suma + parseInt(producto.cantidad);
					});
					totales.push({
						unimed_venta_completa: element,
						cantidad: suma,
					});
				});
			}
			commit('setTotales', totales);
			commit('setImportes', response.data.productos.importes);
			if (response.data.productos.fecha_entrega) commit('setFechaEntrega', moment(response.data.productos.fecha_entrega).format('DD-MM-yyyy'));
			commit('setIdcarrito', response.data.productos.id);
			commit('setTotalPedido', parseFloat(productos.length > 0 ? response.data.productos.importes.importe_total : 0));
			commit('setDetallePedido', response.data.productos.detalle);
			commit('setAlertaPrecio', response.data.productos.alertas);
			commit('setPosiciones', response.data.productos.posiciones);
			commit('setLoadingCarrito', false);
		});
	},
	// async loadProductos({ commit, dispatch }, params: Object): Promise<void> {
	// 	//commit('setLoadingProductos', true);
	// 	return axios.get('./api/public/proxy/pedidos', params).then(response => {
	// 		commit('setProductos', response.data.productos as Producto[]);
	// 		//commit('setLoadingProductos', false);
	// 		commit('setTotal', response.data.total);
	// 	});
	// },
	async loadProductos({ state, commit }, params) {
		const reqId = ++state._prodReqId;
		commit('setLoadingProductos', true);
		try {
			const { data } = await axios.get('./api/public/proxy/pedidos', params);
			if (reqId !== state._prodReqId) return;

			commit('setProductos', data.productos);
			commit('setTotal', data.total);
		} finally {
			if (reqId === state._prodReqId) commit('setLoadingProductos', false);
		}
	},
	//TODO: allproductos es el que mantiene todos los productos, ver si tendria q pasar las otras vistas a éste store
	// async loadAllProductos({ commit, dispatch }, params: Object): Promise<void> {
	// 	commit('setLoadingAllProductos', true);
	// 	return axios
	// 		.get('./api/public/proxy/pedidos', {
	// 			params: params ? params : { filtros: state.filter, start: state.allstart, limit: state.alllimit, page: state.allpage },
	// 		})
	// 		.then(response => {
	// 			const nuevosProductos: Producto[] = response.data.productos as Producto[];
	// 			commit('setAllProductos', nuevosProductos);
	// 			//commit('setProductos', response.data.productos as Producto[]);
	// 			commit('setLoadingAllProductos', false);
	// 			commit('setTotal', response.data.total);
	// 		});
	// },
	async loadAllProductos({ state, commit }, payload) {
		const reqId = ++state._allReqId;
		commit('setLoadingAllProductos', true);

		const finalParams =
			payload && payload.params ? payload.params : { filtros: state.filter, start: state.allstart, limit: state.alllimit, page: state.allpage };

		try {
			const { data } = await axios.get('./api/public/proxy/pedidos', { params: finalParams });

			// si la respuesta no es la última, la ignoramos
			if (reqId !== state._allReqId) return;

			const items = data.productos || [];

			if (state.allstart > 0) {
				// append
				if (items.length) commit('setAllProductos', items);
			} else {
				// replace (tu mutación actual empuja si length>0, así que primero limpio)
				commit('setAllProductos', []); // limpia lista
				if (items.length) commit('setAllProductos', items);
			}

			commit('setTotal', data.total);
		} finally {
			// solo la última request baja el loading
			if (reqId === state._allReqId) commit('setLoadingAllProductos', false);
		}
	},

	async resetAllProductos({ commit, dispatch }) {
		commit('setAllStart', 0);
		commit('setAllLimit', 12);
		commit('setAllPage', 1);
		commit('setAllProductos', []);
	},
	async loadProductoSelected({ commit, dispatch }, producto: Producto): Promise<void> {
		commit('setProductoDetallado', producto);
	},
	async loadProducto({ commit, dispatch }, number: number): Promise<void> {
		return axios.get('./api/public/proxy/pedidos/' + number).then(response => {
			commit('setProductoDetallado', response.data.producto[0] as Producto);
		});
	},
	async loadPendientes({ commit, dispatch }, params: { start: number; limit: number }): Promise<void> {
		let config = { params: { pendientes: true } };
		if (params.start === 0) commit('setPedidosPendientes', []);
		const response = await axios.get(`./api/public/proxy/pedidos?start=${params.start}&limit=${params.limit}`, config);
		if (response.data.productos) {
			response.data.productos.forEach(element => {
				commit('setPedidosPendientes', element);
			});
			return response.data.productos;
		}
	},
	async loadAprobados({ commit, dispatch }, params: { start: number; limit: number }) {
		let config = { params: { aprobados: true } };
		if (params.start === 0) commit('setPedidosAprobados', []);
		const response = await axios.get(`./api/public/proxy/pedidos?start=${params.start}&limit=${params.limit}`, config);
		if (response.data.productos) {
			response.data.productos.forEach(element => {
				commit('setPedidosAprobados', element);
			});
			return response.data.productos;
		}
	},
	async loadAplicados({ commit, dispatch }, params: { start: number; limit: number }) {
		let config = { params: { aplicados: true } };
		if (params.start === 0) commit('setPedidosAplicados', []);
		const response = await axios.get(`./api/public/proxy/pedidos?start=${params.start}&limit=${params.limit}`, config);
		if (response.data.productos) {
			response.data.productos.forEach(element => {
				commit('setPedidosAplicados', element);
			});
			return response.data.productos;
		}
	},
	async loadVisitados({ commit, dispatch }, params: Object): Promise<void> {
		commit('setLoadingVisita', true);
		let config = { params: { visitados: true } };
		return axios.get('./api/public/proxy/pedidos', config).then(response => {
			commit('setVisitados', response.data.productos as Producto[]);
			commit('setLoadingVisita', false);
		});
	},
	async loadComprados({ commit, dispatch }, params: Object): Promise<void> {
		let config = { params: { comprados: true } };
		return axios.get('./api/public/proxy/pedidos', config).then(response => {
			commit('setComprados', response.data.productos as Producto[]);
			//commit('setTotalComprados', response.data.totalcomprados);
		});
	},
	async loadPromociones({ commit, dispatch }, params: Object): Promise<void> {
		let config = { params: { promociones: true } };
		return axios.get('./api/public/proxy/pedidos', config).then(response => {
			commit('setPromociones', response.data.productos as Producto[]);
		});
	},
	async asyncloadFdepagos({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=fdepagos').then(response => {
			commit('setFdepagos', response.data.productos);
		});
	},
	async loadDentregas({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=dentregas').then(response => {
			commit('setDentregas', response.data.productos);
			return response.data.productos;
		});
	},
	async loadTorigen({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=torigen').then(response => {
			commit('setTorigen', response.data.productos);
			return response.data.productos;
		});
	},
	async loadToperacion({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/pedidos?type=toperacion').then(response => {
			commit('setToperacion', response.data.productos);
			return response.data.productos;
		});
	},
	async putCantidad({ commit, dispatch }, producto: { pedido_id: number }): Promise<void> {
		return axios.put('./api/public/proxy/pedidos/' + producto['pedido_id'] + '?type=carrito&suma=false', producto).then(response => {
			this.dispatch('loadCarrito');
		});
	},
	async putDentrega({ commit, dispatch }, producto: { pedido_id: number; dentrega: number }): Promise<void> {
		commit('setEntrega', producto['dentrega']);
		return axios
			.put('./api/public/proxy/pedidos/' + producto['pedido_id'] + '?type=condiciones&dentrega=' + producto['dentrega'], producto)
			.then(response => {
				commit('setEntrega', producto['dentrega']);
				this.dispatch('loadCarrito');
			});
	},
	async putOrigen({ commit, dispatch }, condicion: { pedido_id: number; origen: number }): Promise<void> {
		return axios
			.put('./api/public/proxy/pedidos/' + condicion['pedido_id'] + '?type=condiciones&origen=' + condicion['origen'], condicion)
			.then(response => {
				this.dispatch('loadCarrito');
			});
	},
	async putOperacion({ commit, dispatch }, condicion: { pedido_id: number; origen: number }): Promise<void> {
		return axios
			.put('./api/public/proxy/pedidos/' + condicion['pedido_id'] + '?type=condiciones&operacion=' + condicion['operacion'], condicion)
			.then(response => {
				this.dispatch('loadCarrito');
			});
	},
	async putFechaEntrega({ commit, dispatch }, producto: { pedido_id: number; fecha_entrega: number }): Promise<void> {
		commit('setFechaEntrega', producto['fecha_entrega']);
		return axios
			.put('./api/public/proxy/pedidos/' + producto['pedido_id'] + '?type=condiciones&fecha_entrega=' + producto['fecha_entrega'], producto)
			.then(response => {
				commit('setFechaEntrega', producto['fecha']);
				this.dispatch('loadCarrito');
			});
	},
	async putDetalle({ commit, dispatch }, condicion: { pedido_id: number; detalle: string }): Promise<void> {
		return axios
			.put('./api/public/proxy/pedidos/' + condicion['pedido_id'] + '?type=condiciones&detalle=' + condicion['detalle'], condicion)
			.then(response => {
				this.dispatch('loadCarrito');
			});
	},
	async loadPedidos({ commit, dispatch }, params: Object): Promise<void> {
		commit('setLoadingHistorial', true);
		return axios.get('./api/public/proxy/pedidos', params).then(response => {
			commit('setTotalPedidos', response.data.total);
			commit('setPedidos', response.data.productos);
			commit('setLoadingHistorial', false);
		});
	},
	async addAlerta({ commit, dispatch }, param) {
		console.log('agegar alerta al producto', param);
		return axios.post('./api/public/proxy/pedidos/addAlerta', param).then(response => {
			console.log('esto devuelve', response);
		});
	},
	async deleteAlerta({ commit, dispatch }, param) {
		return axios.post('./api/public/proxy/pedidos/deleteAlerta', param).then(response => {
			console.log('esto devuelve', response);
		});
	},
	async loadEntitityData({ commit, dispatch }) {
		commit('setLoadingProductos', true);
		try {
			const r = await axios
				.get('./api/public/proxy/cgi/etenet_prodxenti')
				.then(async response => {
					//commit('setLoadingProductos', false);
					return response.status;
				})
				.catch(() => {});
			return r;
		} catch (error) {
			console.log('ERROR', error);
			commit('setLoadingProductos', false);
		}
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	//namespaced: true,
	state,
	//getters,
	actions,
	mutations,
};
